import React, { FC } from "react";

const UserStatusBadge: FC<{ status: string }> = ({ status }) => {
  if (status === "Active") {
    return <span className="badge badge-primary">Active</span>;
  } else if (status === "Deleted") {
    return <span className="badge badge-danger">Deleted</span>;
  } else if (status === "Pending") {
    return <span className="badge badge-warning">Pending</span>;
  } else if (status === "Inactive") {
    return <span className="badge badge-dark">Disabled</span>;
  } else {
    return <span>-</span>;
  }
};

export default UserStatusBadge;
